import { z } from "zod/v4-mini";

import { Schema } from "@/utils/zodUtils.ts";

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export type FileModel = {
  url: string;
  name: string;
  path: string;
};

export const fileSchema: Schema<FileModel> = z.object({
  url: z.string(),
  name: z.string(),
  path: z.string(),
});

export type FileToUpload = {
  file?: Blob;
  name: string;
};

export type UploadedFileType = "description" | "prescriptions" | "messages" | "treatment" | "referral_letter";

export type UploadFileModel = {
  file: File;
  type: UploadedFileType;
  patient_firstname: string;
  patient_lastname: string;
};
